jQuery(function () {
  class ListSummarizer {
    constructor() {
      this.toggleLinkSelector = "[data-behaviour=list-summarizer-toggle]";
      this.summarizedItemSelector = ".add-on-list-item-container:nth-child(n+6)";

      jQuery(this.toggleLinkSelector).each((index, link) => {
        link = jQuery(link);
        this.addListener(link);
        this.toggle(link);
      });
    }

    addListener(link) {
      link.on("click", (event) => {
        event.preventDefault();
        link.data("summarized", !link.data("summarized"));
        this.toggle(link);
      });
    }

    toggle(link) {
      var list = jQuery("#" + link.data("list-id"));
      list.find(this.summarizedItemSelector).toggle(!link.data("summarized"));
      link.html(link.data(link.data("summarized") ? "summarized-text" : "unsummarized-text"));
    }
  }

  new ListSummarizer();
});
